import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { faStethoscope } from '@fortawesome/pro-solid-svg-icons/faStethoscope'
import { getAllConditionNames } from '@modules/conditions/helpers/getAllConditionNames'
import type { ClinicalTrialCondition, Condition } from '@prisma/client'

type ConditionAssociation = ClinicalTrialCondition & {
  condition: Pick<
    Condition,
    | 'id'
    | 'meshId'
    | 'name'
    | 'preferredTerm'
    | 'colloquialTerm'
    | 'colloquialAcronym'
    | 'colloquialTermStripped'
    | 'umlsTreeNumber'
  >
}

export default function ConditionsCard({
  conditions,
}: {
  conditions: ConditionAssociation[]
}) {
  if (conditions.length <= 1) {
    return null
  }
  const conditionsToRender = getAllConditionNames(conditions)
  return (
    <div className='lg:mt-8'>
      <div className='mb-2 flex flex-row items-center justify-start gap-2'>
        <Text
          className='text-left text-neutral900'
          styleName='h5'
          value='Eligible Conditions'
        />
        <Icon icon={faStethoscope} />
      </div>
      <ul className='ml-4 list-disc text-neutral600'>
        {conditionsToRender.map((condition) => (
          <li key={condition}>
            <Text
              className={'text-neutral600'}
              styleName='p'
              value={condition}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
